import { render, staticRenderFns } from "./SmsTemplatesTable.vue?vue&type=template&id=215a3a64"
import script from "./SmsTemplatesTable.vue?vue&type=script&lang=js"
export * from "./SmsTemplatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports